
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/baseUI/aiTermsAndConditions/aiTermsAndConditions.scss.css.virtualfile';
        module.exports = {"text":"_text_y2n1q_1"};